// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:domain\",\"regex\":\"^/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"domain\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[\"/:locale/:domain\"]}";globalThis["_sentryNextJsVersion"] = "16.3.1";import * as Sentry from '@sentry/nextjs';

import '@cineamo/ui/src/polyfills';

Sentry.init({
    dsn: 'https://3f2edafc9cce132af0716e4e1c46743d@o1087176.ingest.us.sentry.io/4510322787418112',

    // Enable sending user PII (Personally Identifiable Information)
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: false
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
